import { Decoder } from '@mojotech/json-type-validation'

export type RequestFunction = (path: string, option?: {}) => Promise<Response>

export class ApiClient {
  constructor(private request: RequestFunction) {}

  async fetchAndDecode<T>(decoder: Decoder<T>, path: string, option?: {}): Promise<T> {
    const response = await this.request(path, option)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const jsonData = await response.json()

    try {
      return await decoder.runPromise(jsonData)
    } catch (decodeError) {
      console.error('Decoding error:', decodeError)
      throw new Error('Failed to decode the response data')
    }
  }

  async fetch<T>(path: string, option?: {}): Promise<T> {
    const response = await this.request(path, option)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const jsonData = await response.json()
    return jsonData
  }

  async post<T>(path: string, option?: {}) {
    await this.request(path, option)
  }
}
